import { twitchService } from '../lib/twitch';
import './Login.css';
import r3dlabsLogo from '../assets/images/powered-by-r3dlabs.png?url';

export function createLoginPage(): HTMLElement {
  const container = document.createElement('div');
  container.className = 'login-container';

  const loginCard = document.createElement('div');
  loginCard.className = 'login-card';

  const logoDiv = document.createElement('div');
  logoDiv.className = 'login-logo';
  logoDiv.innerHTML = `
    <img src="/assets/images/firepanel.png"/>
    <span class="logon-logo-text">FirePanel</span>
  `;

  const description = document.createElement('p');
  description.className = 'login-description';
  description.innerHTML = 'A Raid and Stream HUD For Twitch Streamers.<br><br>Login with Twitch to get started.';

  const loginBtn = document.createElement('button');
  loginBtn.className = 'twitch-login-button';
  loginBtn.innerHTML = `
    <svg class="twitch-icon" viewBox="0 0 24 24" fill="currentColor">
      <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>
    </svg>
    Login with Twitch
  `;
  loginBtn.addEventListener('click', () => {
    twitchService.initiateLogin();
  });

  const footer = document.createElement('p');
  footer.className = 'login-footer';
  
  const r3dlabsLink = document.createElement('a');
  r3dlabsLink.href = 'https://r3dlabs.com';
  r3dlabsLink.target = '_blank';
  
  const r3dlabsImage = document.createElement('img');
  r3dlabsImage.style.width = '150px';
  r3dlabsImage.src = r3dlabsLogo;
  
  r3dlabsLink.appendChild(r3dlabsImage);
  
  const obsLink = document.createElement('div');
  obsLink.style.marginTop = '0px';
  obsLink.innerHTML = `
    <a style="color:#3B82F6" href="https://docs.r3dlabs.com/add-firepanel-to-obs" target="_blank">
      Click Here For OBS Dock Setup Instructions
    </a>
  `;
  
  footer.appendChild(r3dlabsLink);
  footer.appendChild(obsLink);

  loginCard.appendChild(logoDiv);
  loginCard.appendChild(description);
  loginCard.appendChild(loginBtn);
  loginCard.appendChild(footer);
  
  container.appendChild(loginCard);

  return container;
}
